import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Forside from './pages/Forside';
import OmOs from './pages/OmOs';
import Jordvarme from './pages/Jordvarme';
import MidlertidigVej from './pages/MidlertidigVej';
import Belægning from './pages/Belægning';
import Fundamenter from './pages/Fundamenter';
import Tilbygning from './pages/Tilbygning';
import LCA from './pages/LCA';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import './App.css';
import Kontakt from './pages/Kontakt';
import Admin from './pages/Admin';
import Cookies from './pages/Cookies';
import NotFound from './pages/NotFound';

import CookieConsent from 'react-cookie-consent';
import CookieSettingsButton from './components/CookieSettingsButton';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';

library.add(faPhone, faEnvelope);

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Routes>
            <Route path="/" element={<Forside />} />
            <Route path="/om-os" element={<OmOs />} />
            <Route path="/historie" element={<Navigate to="/om-os" replace />} />
            <Route path="/jordvarme" element={<Jordvarme />} />
            <Route path="/midlertidig-vej" element={<MidlertidigVej />} />
            <Route path="/belægning" element={<Belægning />} />
            <Route path="/fundamenter" element={<Fundamenter />} />
            <Route path="/tilbygning" element={<Tilbygning />} />
            <Route path="/lca" element={<LCA />} />
            <Route path="/bitumix" element={<Navigate to="/" replace />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/kloak" element={<Navigate to="/" replace />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
        </div>
        <CookieConsent
          location="bottom"
          buttonText="Accepter"
          declineButtonText="Afvis"
          enableDeclineButton
          cookieName="jbc-cookie-consent"
          style={{ background: '#1e3a8a', fontSize: '14px', alignItems: 'center' }}
          buttonStyle={{ background: '#ffffff', color: '#1e3a8a', fontSize: '14px', borderRadius: '8px', padding: '8px 20px', fontWeight: '700' }}
          declineButtonStyle={{ background: 'transparent', color: '#ffffff', fontSize: '14px', borderRadius: '8px', padding: '8px 20px', border: '1px solid #ffffff' }}
          expires={365}
        >
          Vi bruger cookies for at forbedre din oplevelse på vores hjemmeside. Ved at klikke "Accepter" accepterer du vores brug af cookies.{' '}
          <a href="/cookies" style={{ color: '#ffffff', textDecoration: 'underline' }}>Læs mere</a>
        </CookieConsent>
        <CookieSettingsButton />
      </Router>
    </HelmetProvider>
  );
}

export default App;
